import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

const SocketContext = createContext();

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    
    if (token) {
      const newSocket = io(SOCKET_URL, {
        auth: { token },
        withCredentials: true,
        transports: ['polling', 'websocket'],
        autoConnect: true,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000
      });

      newSocket.on('connect', () => {
        const userId = localStorage.getItem('userId');
        if (userId) {
          newSocket.emit('joinRoom', `customer_${userId}`);
        }
      });

      newSocket.on('connect_error', (error) => {
        console.error('Socket anslutningsfel:', error.message);
      });

      newSocket.on('disconnect', (reason) => {
      });

      newSocket.on('reconnect_attempt', (attemptNumber) => {
      });

      setSocket(newSocket);

      return () => {
        if (newSocket) {
          newSocket.disconnect();
        }
      };
    }
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
